/**
 * 将二进制数据转成需要的数组数据
 * @param binStr 二进制字符串
 * @param originalData 模块数据，用于匹配二进制
 * @returns
 */
export const getIntegrityCheckArr = (
  binStr: string,
  originalData: Recordable[]
) => {
  const binArr = binStr?.split('') ?? [];
  return (
    originalData?.map((item: any) => {
      const { status, index, isDefault } = item;
      return {
        ...item,
        status: isDefault ? 1 : Number(binArr[index] ?? status),
      };
    }) ?? []
  );
};

export default getIntegrityCheckArr;
